
import posthog from 'posthog-js';
import { toast } from 'react-toastify';
import { logout } from '../redux/slices/authSlice';
import axiosInstance from './axiosInstance';
import { persistor } from '../redux/store';
import { clearSessionUUID } from '../utils/uuidManager';

export const fetchUserInfo = async () => {
  try {
    const response = await axiosInstance.get('/auth/me/');
    return { success: true, data: response?.data?.data };
  } catch (error) {
    console.error('Error fetching user info:', error.response);
    return {
      success: false,
      error:
        error?.response?.data?.detail ||
        error?.response?.data?.message ||
        error?.message ||
        'An error occurred while fetching user info.',
    };
  }
};
export const handleLogout = async (dispatch) => {
  try {
    await axiosInstance.post("/auth/logout/", {}, { withCredentials: true });

    dispatch(logout());
    posthog.reset();
    persistor.purge();
    clearSessionUUID(); // Clear UUID on logout
  } catch (error) {
    console.error("Logout error:", error?.response || error);
    toast.error("Error logging out: " + (error?.message || "Unknown error"));
  }
};
